module.exports = __webpack_public_path__ + "static/img/challenge.f740382c.png";